<cap-content-header>
  <cap-title>
    {{ "grundstueck.ListTitel" | translate }}
  </cap-title>
  <cap-title-functionbar>
    @if (grundstueckIds.length >= 2) {
      <button
        (click)="getZip()"
        [disabled]="gbPrintService.zipInProgressMap.get(0)"
        class="btn btn-outline-primary btn-sm me-2"
        type="button">
        @if (gbPrintService.zipInProgressMap.get(0)) {
          <span class="spinner-border spinner-border-sm text-primary me-1"></span>
        }
        {{ "Auszüge" | translate }} {{ "(" + grundstueckIds.length + ")" }}
      </button>
    }
    <cap-functionbar-searchresult-buttons [listLoader]="grundstueckLoader"></cap-functionbar-searchresult-buttons>
  </cap-title-functionbar>
</cap-content-header>

@if (grundstuecksResponse) {
  <cap-grundstueck-table
    (grundstueckIdsListEventItem)="updateCheckedGrundstueckIdList($event)"
    [listLoader]="grundstueckLoader"
    [showZeilenSelect]="false">
  </cap-grundstueck-table>
} @else {
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-1 text-center">
        <cap-spinner-small></cap-spinner-small>
      </div>
    </div>
  </div>
}
